import { track } from "@homeinstead/analytics";
import { EventName } from "@homeinstead/shared";
import { TrackedClickEvent } from "~www/types/events";

function trackSearchToggleClick(is_open: boolean) {
  track(EventName.TRACKED_CLICK, {
    ...TrackedClickEvent({
      element_name: "search_locations_toggle",
    }),
    is_open,
  });
}

function trackSearchSubmitButtonClick() {
  track(
    EventName.TRACKED_CLICK,
    TrackedClickEvent({
      element_name: "search_locations_submit",
    }),
  );
}

function trackSearchResultClick() {
  track(
    EventName.TRACKED_CLICK,
    TrackedClickEvent({
      element_name: "search_locations_result_click",
    }),
  );
}

function trackMapClick() {
  track(
    EventName.TRACKED_CLICK,
    TrackedClickEvent({
      element_name: "search_locations_map_click",
    }),
  );
}

export {
  trackMapClick,
  trackSearchResultClick,
  trackSearchSubmitButtonClick,
  trackSearchToggleClick,
};
